<template>
  <div class="home-pannel">
    <div class="home-pannel-title titleed" style="display:flex;justify-content:space-between;">
      <span>回款未开票列表 </span>
      <div @click="showMoreClick" class="moreText">查看更多</div>
    </div>
    <div style="padding: 10px">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="tableLoadding"
        :pagination="tablePagination"
        :scroll="{ y: 190 }"
        @change="pageChange"
        size="small"
        bordered
        class="tableClass"
      >
        <template slot="backMoneySlot" slot-scope="text, record">
          <span>{{ (record.backMoney !== null && record.backMoney !== '') ? '￥' + parseFloat(record.backMoney).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : record.backMoney }}</span>
        </template>
        <template slot="projectNameSlot" slot-scope="text, record">
          <span class="onClickStyle" @click="viewClick(record, 'project')">{{ record.projectName }}</span>
        </template>
        <template slot="customerNameSlot" slot-scope="text, record">
          <span class="onClickStyle" @click="viewClick(record, 'customer')">{{ record.customerName }}</span>
        </template>
        <template slot="contractNameSlot" slot-scope="text, record">
          <span class="onClickStyle" @click="viewClick(record, 'contract')">{{ record.contractName }}</span>
        </template>
        <template slot="backType" slot-scope="text, record">
          <a-tag :color="record.backType === 0 ? '#87d068' : '#108ee9'">{{ record.backType === 0 ? '回款计划' : '回款记录' }}</a-tag>
        </template>
        <template slot="backInvoice" slot-scope="text, record">
          <span v-if="record.backInvoice === 0">否</span>
            <span v-else-if=" record.backInvoice === 1">
              <a-icon type="check-square" theme="twoTone" two-tone-color="#52c41a"/>
            </span>
          <span v-else-if=" record.backInvoice === 2">无需开票</span>
        </template>
        <template slot="backDateSlot" slot-scope="text, record">
          <!-- 回款计划-实际回款日期   回款记录-回款日期 -->
          <span v-if="record.backType === 0">{{ record.backDateActual }}</span>
          <span v-if="record.backType === 1">{{ record.backDate }}</span>
        </template>
        <template slot="operation" slot-scope="text, record">
          <span class="operationStyle" style="color:#1890ff;" @click="editClick(record)">开票</span>
        </template>
      </a-table>
    </div>
    <click-view
      ref="clickViewRef"
      :dialog-visible="clickViewVisible"
      @close="clickViewClose"
    />
  </div>
</template>

<script>
import clickView from '@/components/view/clickView.vue'
export default {
  components: { clickView },
  data () {
    return {
      tableData: [],
      tableLoadding: false,
      tablePagination: {
        pageSize: 5,
        pageNum: 1,
        total: 0,
        pageSizeOptions: [ '5', '10', '15', '20' ],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      columns: [
        {
          title: 'ID',
          width: 60,
          fixed: 'left',
          sorter: (a, b) => a.id - b.id,
          align: 'center',
          dataIndex: 'id',
          ellipsis: true
        },
        {
          width: 150,
          align: 'center',
          fixed: 'left',
          sorter: (a, b) => a.backMoney - b.backMoney,
          title: '金额',
          dataIndex: 'backMoney',
          scopedSlots: { customRender: 'backMoneySlot' },
          ellipsis: true
        },
        {
          ellipsis: true,
          align: 'center',
          title: '对应项目',
          dataIndex: 'projectName',
          scopedSlots: { customRender: 'projectNameSlot' }
        },
        {
          ellipsis: true,
          align: 'center',
          title: '对应客户',
          dataIndex: 'customerName',
          scopedSlots: { customRender: 'customerNameSlot' }
        },
        {
          width: 170,
          ellipsis: true,
          align: 'center',
          title: '合同订单',
          dataIndex: 'contractName',
          scopedSlots: { customRender: 'contractNameSlot' }
        },
        {
          width: 100,
          align: 'center',
          title: '回款日期',
          dataIndex: 'backDate',
          ellipsis: true,
          scopedSlots: { customRender: 'backDateSlot' }
        },
        {
          width: 90,
          ellipsis: true,
          align: 'center',
          title: '类型',
          dataIndex: 'backType',
          scopedSlots: { customRender: 'backType' }
        },
        {
          width: 120,
          align: 'center',
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          ellipsis: true
        }
      ],
      clickViewVisible: false
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    pageChange (pageVal) {
      this.tablePagination.current = pageVal.current
      this.tablePagination.pageNum = pageVal.current
      this.tablePagination.pageSize = pageVal.pageSize
      this.initData()
    },
    initData () {
      this.tableLoadding = true
      let params = {}
      params.backInvoice = 0
      params.pageSize = this.tablePagination.pageSize
      params.pageNum = this.tablePagination.pageNum
      this.$get('/payBack/list', {...params}).then(res => {
        if (res.data.status === 1) {
          this.tableData = res.data.data.rows
          this.tablePagination.total = Number(res.data.data.total)
        }
      }).finally(() => {
        setTimeout(() => {
          this.tableLoadding = false
        }, 200)
      })
    },
    viewClick (rowVal, val) {
      switch (val) {
        case 'project':
          if (rowVal.projectId) {
            this.clickViewVisible = true
            this.$refs.clickViewRef.openView('project', rowVal, rowVal.projectId)
          }
          break
        case 'customer':
          if (rowVal.customerId) {
            this.clickViewVisible = true
            this.$refs.clickViewRef.openView('customer', rowVal, rowVal.customerId)
          }
          break
        case 'contract':
          if (rowVal.contractId) {
            this.clickViewVisible = true
            this.$refs.clickViewRef.openView('contract', rowVal, rowVal.contractId)
          }
          break
      }
    },
    clickViewClose () {
      this.clickViewVisible = false
    },
    editClick (item) {
      this.$emit('invoiceListChange', item)
    },
    initDataCom () {
      this.initData()
    },
    showMoreClick () {
      this.$router.push({path: 'contractManage/paymentPlan', query: {backInvoice: 0}})
    }
  }
}
</script>

<style lang="less" scoped>
  .moreText{
    cursor: pointer;
    height: 30px;
    padding: 0 6px;
    border:1px solid #e1e1e1;
    border-radius:20px;
    margin-top: 10px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
  }
    .moreText:hover{
      background-color: #e9e9e9;
    }
  .titleed{
    display: flex;
    &-sele{
      font-weight: 500;
    }
  }
    .panel {
      padding-bottom: 0.6rem;
      background-color: #fff;
      border: 1px solid transparent;
      border-radius: 10px;

      .panel-title {
        width: 100%;
        border-bottom: solid 1px #e9e9e9;
        line-height: 50px;
        padding-left: 15px;
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 30px;
          background-color: #0079fe;
          position: absolute;
          left: 0;
          top: 10px;
          border-radius: 4px;
        }

        span {
          &:first-child {
            font-size: 18px !important;
            font-weight: 400;
          }
        }
      }
    }
  .tableClass{
    /deep/ .ant-table-pagination.ant-pagination{
      margin: 10px 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/invoiceList.vue